/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	AdditionalQuestionIndexPathParams,
	AdditionalQuestionIndexResponse,
} from '../types/AdditionalQuestionIndex'

/**
 * GET /forms/:form/additional-questions
 * @see backend/nexus/modules/Form/Http/Controllers/AdditionalQuestionController.php AdditionalQuestionController::index
 */
export async function additionalQuestionIndex(
	form: AdditionalQuestionIndexPathParams['form'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AdditionalQuestionIndexResponse>> {
	return axiosInstance.get(`/forms/${form}/additional-questions`, config)
}
